import { motion } from "framer-motion";
import { Quote, Building2 } from "lucide-react";

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 lg:py-32 bg-[#F4F5F7]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A00] mb-4 font-mono-tech" data-testid="testimonials-overline">
            Testimonials • 05
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-[#0F172A]" data-testid="testimonials-heading">
            Trusted by Houston's Engineers
          </h2>
          <p className="mt-6 text-base text-slate-600 leading-relaxed">
            Engineering firms across Greater Houston count on Aegis Subsurface for dependable field work.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6" data-testid="testimonials-grid">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="lg:col-span-8 bg-[#0F172A] border-l-4 border-[#FF5A00] rounded-sm p-10 lg:p-14 relative overflow-hidden"
            data-testid="testimonial-card-allterra"
          >
            <Quote className="absolute top-8 right-8 w-16 h-16 text-white/5" />
            <p className="font-heading text-2xl sm:text-3xl font-bold text-white leading-snug max-w-2xl">
              Responsive field crews, accurate documentation, and scheduling we can plan around. That's why{" "}
              <span className="text-[#FF5A00]">All Terra Engineering</span> works with Aegis Subsurface.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <span className="w-12 h-12 bg-[#FF5A00] rounded-sm flex items-center justify-center">
                <Building2 className="w-6 h-6 text-white" />
              </span>
              <div>
                <p className="font-heading font-bold uppercase tracking-wider text-white">All Terra Engineering</p>
                <p className="text-sm text-slate-400">Geotechnical Engineering Partner, Houston, TX</p>
              </div>
            </div>
          </motion.div>

          <motion.a
            href="#quote"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: 0.1, ease: "easeOut" }}
            className="lg:col-span-4 bg-white border border-slate-200 rounded-sm p-10 flex flex-col justify-between transition-all duration-200 hover:-translate-y-1 hover:shadow-[6px_6px_0px_#0F172A] hover:border-[#0F172A]"
            data-testid="testimonial-cta-card"
          >
            <h3 className="font-heading text-xl font-bold uppercase tracking-tight text-[#0F172A]">
              Your project could be next
            </h3>
            <p className="mt-6 text-sm font-semibold uppercase tracking-wider text-[#FF5A00] underline underline-offset-4">
              Start a quote →
            </p>
          </motion.a>
        </div>
      </div>
    </section>
  );
}
